import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { Task } from "../../models/Task";
import { useTask } from "../../contexts/TaskContext";
import { Table, TableBody } from "../../design/table";
import TaskListItem from "./components/TaskListItem";
import { Subheading } from "../../design/heading";

interface Props {
  taskType: Task["type"];
}

const TasksComponent: React.FC<Props> = ({ taskType }) => {
  const { tasks } = useTask();
  const filteredTasks = tasks.filter(
    (task) => task.type === taskType && !task.isCompleted,
  );
  if (!filteredTasks || filteredTasks.length === 0) return null;
  return (
    <div className="p-4 pt-4 my-4 bg-white border rounded-md shadow-lg dark:bg-black">
      <Subheading>Tasks</Subheading>
      <Table>
        <TableBody>
          {filteredTasks.map((task) => (
            <TaskListItem key={task._id} task={task} />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default TasksComponent;
